import { TenantBrandPanelView } from '@today/ui-domain'
import { useTenantBrand } from '@/hooks/useTenantBrand'
import type { TenantConfigSectionProps } from '../section-props'

/**
 * The console's `brand` section (TO-380). The Super-Admin (platform plane, EDIT)
 * picks a published brand and saves it; a Tenant Admin (tenant plane, READ)
 * sees the current brand read-only. The server decides the access.
 */
export function BrandSection({ tenantId, tenantSlug, plane, readOnly }: TenantConfigSectionProps) {
	const brand = useTenantBrand({ plane, tenantId, tenantSlug, editable: !readOnly })

	if (brand.loadFailed) {
		return (
			<div role="alert" className="flex flex-col items-start gap-3 text-sm text-ds-danger">
				<p>Could not load the brand.</p>
				<button type="button" onClick={brand.reload} className="rounded-md border px-3 py-1">
					Try again
				</button>
			</div>
		)
	}
	if (!brand.view || (!readOnly && !brand.catalog)) {
		return (
			<p className="text-sm text-ds-text-muted" aria-live="polite">
				Loading brand…
			</p>
		)
	}
	return (
		<TenantBrandPanelView
			brand={brand.view.brand}
			editor={
				readOnly || !brand.catalog
					? undefined
					: {
							options: brand.catalog,
							selectedId: brand.selectedId,
							onSelect: brand.select,
							onSave: brand.save,
							saving: brand.saving,
							error: brand.saveError,
						}
			}
		/>
	)
}
